(function(){
  var cartApi = null;

  function rootUrl(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function escapeHtml(value){
    return String(value == null ? '' : value).replace(/[&<>'"]/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch];
    });
  }

  function money(cents,currency){
    var amount=(Number(cents)||0)/100;
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'lt-LT',{style:'currency',currency:currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'}).format(amount);
    }catch(e){
      return amount.toFixed(2).replace('.',',')+' €';
    }
  }

  function createCartApi(shell){
    var itemsEl=shell.querySelector('[data-cart-drawer-items]');
    var removeLabel=(itemsEl && itemsEl.dataset.removeLabel) || 'Pašalinti';
    var emptyEl=shell.querySelector('[data-cart-drawer-empty]');
    var footerEl=shell.querySelector('[data-cart-drawer-footer]');
    var loadingEl=shell.querySelector('[data-cart-drawer-loading]');
    var subtotalEl=shell.querySelector('[data-cart-subtotal]');
    var titleCountEl=shell.querySelector('[data-cart-title-count]');
    var openers=document.querySelectorAll('[data-cart-drawer-open]');
    var lastFocus=null;

    function setCount(count){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent=count;
        el.classList.toggle('is-empty',count===0);
      });
      if(titleCountEl) titleCountEl.textContent=count>0 ? '('+count+')' : '';
    }

    function render(cart){
      setCount(cart.item_count || 0);
      if(loadingEl) loadingEl.hidden=true;
      if(!cart.items || cart.items.length===0){
        if(itemsEl) itemsEl.innerHTML='';
        if(emptyEl) emptyEl.hidden=false;
        if(footerEl) footerEl.hidden=true;
        return;
      }
      if(emptyEl) emptyEl.hidden=true;
      if(footerEl) footerEl.hidden=false;
      if(subtotalEl) subtotalEl.textContent=money(cart.total_price,cart.currency);
      if(itemsEl){
        itemsEl.innerHTML=cart.items.map(function(item,index){
          var image=item.image ? '<a class="cart-drawer-item-image" href="'+escapeHtml(item.url || '#')+'"><img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.product_title || item.title || '')+'" loading="lazy"></a>' : '<div class="cart-drawer-item-image"></div>';
          var variant=(item.variant_title && item.variant_title!=='Default Title') ? '<div class="cart-drawer-item-variant">'+escapeHtml(item.variant_title)+'</div>' : '';
          return '<div class="cart-drawer-item" data-cart-line="'+(index+1)+'">'+
            image+
            '<div class="cart-drawer-item-info">'+
              '<div class="cart-drawer-item-top"><div><a class="cart-drawer-item-title" href="'+escapeHtml(item.url || '#')+'">'+escapeHtml(item.product_title || item.title || '')+'</a>'+variant+'</div><div class="cart-drawer-item-price">'+money(item.final_line_price,cart.currency)+'</div></div>'+
              '<div class="cart-drawer-item-bottom"><div class="cart-drawer-qty"><button type="button" data-cart-drawer-change="-1" aria-label="Mažinti kiekį">−</button><span>'+item.quantity+'</span><button type="button" data-cart-drawer-change="1" aria-label="Didinti kiekį">+</button></div><button type="button" class="cart-drawer-remove" data-cart-drawer-remove>'+escapeHtml(removeLabel)+'</button></div>'+
            '</div></div>';
        }).join('');
      }
    }

    function refresh(){
      if(loadingEl) loadingEl.hidden=false;
      return fetch(rootUrl()+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){if(!r.ok) throw new Error('cart-load');return r.json();})
        .then(function(cart){render(cart);return cart;})
        .catch(function(){
          if(loadingEl) loadingEl.hidden=true;
          if(itemsEl) itemsEl.innerHTML='<div class="cart-drawer-error">Krepšelio nepavyko įkelti. <a href="'+rootUrl()+'cart">Atidaryti krepšelio puslapį</a>.</div>';
          throw new Error('cart-load');
        });
    }

    function open(){
      lastFocus=document.activeElement;
      shell.classList.add('is-open');
      shell.setAttribute('aria-hidden','false');
      document.body.classList.add('cart-drawer-open');
      openers.forEach(function(b){b.setAttribute('aria-expanded','true')});
      refresh().finally(function(){
        var close=shell.querySelector('.cart-drawer-close');
        if(close) close.focus({preventScroll:true});
      });
    }

    function close(){
      shell.classList.remove('is-open');
      shell.setAttribute('aria-hidden','true');
      document.body.classList.remove('cart-drawer-open');
      openers.forEach(function(b){b.setAttribute('aria-expanded','false')});
      if(lastFocus && typeof lastFocus.focus==='function') lastFocus.focus({preventScroll:true});
    }

    function change(line,quantity,itemEl){
      if(itemEl) itemEl.classList.add('is-updating');
      return fetch(rootUrl()+'cart/change.js',{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({line:line,quantity:Math.max(0,quantity)})
      }).then(function(r){if(!r.ok) throw new Error('cart-change');return r.json();})
        .then(function(cart){render(cart);document.dispatchEvent(new CustomEvent('genys:cart-updated',{detail:{cart:cart}}));return cart;})
        .catch(function(){if(itemEl)itemEl.classList.remove('is-updating');});
    }

    shell.addEventListener('click',function(e){
      if(e.target.closest('[data-cart-drawer-close]')){close();return;}
      var changeBtn=e.target.closest('[data-cart-drawer-change]');
      var removeBtn=e.target.closest('[data-cart-drawer-remove]');
      if(!changeBtn && !removeBtn) return;
      var itemEl=e.target.closest('[data-cart-line]');
      if(!itemEl) return;
      var line=parseInt(itemEl.dataset.cartLine,10);
      var qtyEl=itemEl.querySelector('.cart-drawer-qty span');
      var current=parseInt(qtyEl ? qtyEl.textContent : '1',10)||1;
      var next=removeBtn ? 0 : Math.max(0,current+parseInt(changeBtn.dataset.cartDrawerChange,10));
      change(line,next,itemEl);
    });

    document.addEventListener('keydown',function(e){if(e.key==='Escape' && shell.classList.contains('is-open')) close();});
    document.addEventListener('genys:cart-open',open);
    document.addEventListener('genys:cart-updated',function(e){
      if(e.detail && e.detail.cart) render(e.detail.cart); else refresh();
    });
    openers.forEach(function(btn){
      if(btn.dataset.cartDrawerInit) return;
      btn.dataset.cartDrawerInit='1';
      btn.addEventListener('click',open);
    });

    return {open:open,close:close,refresh:refresh,render:render};
  }

  function initCartDrawer(root){
    var shell=document.querySelector('[data-cart-drawer-shell]');
    if(!shell) return;
    if(!shell.dataset.cartDrawerInit){
      shell.dataset.cartDrawerInit='1';
      cartApi=createCartApi(shell);
    }else if(cartApi){
      root.querySelectorAll('[data-cart-drawer-open]').forEach(function(btn){
        if(btn.dataset.cartDrawerInit) return;
        btn.dataset.cartDrawerInit='1';
        btn.addEventListener('click',cartApi.open);
      });
    }
  }

  function init(root){
    root = root || document;
    initCartDrawer(root);

    root.querySelectorAll('[data-countdown]').forEach(function(el){
      if(el.dataset.timerInit) return;
      el.dataset.timerInit = '1';
      function update(){
        var now = new Date();
        var target = new Date();
        var daysUntilSunday = (7 - now.getDay()) % 7 || 7;
        target.setDate(now.getDate() + daysUntilSunday);
        target.setHours(23,59,59,0);
        var diff = Math.max(0,target-now);
        var h = String(Math.floor(diff/3600000)).padStart(2,'0');
        var m = String(Math.floor((diff%3600000)/60000)).padStart(2,'0');
        var s = String(Math.floor((diff%60000)/1000)).padStart(2,'0');
        el.textContent = h+':'+m+':'+s;
      }
      update(); setInterval(update,1000);
    });

    root.querySelectorAll('[data-gallery]').forEach(function(gallery){
      if(gallery.dataset.galleryInit) return;
      gallery.dataset.galleryInit='1';
      var main = gallery.querySelector('[data-main-image]');
      var mainVideoWrap = gallery.querySelector('[data-main-video-wrap]');
      var mainVideo = mainVideoWrap ? mainVideoWrap.querySelector('video') : null;
      var mainWrap = gallery.querySelector('.gallery-main');
      var thumbsWrap = gallery.querySelector('.thumbs');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      var activeIndex = Math.max(0,thumbs.findIndex(function(t){return t.classList.contains('active');}));

      function showMedia(index){
        if(!thumbs.length) return;
        if(index < 0) index = thumbs.length - 1;
        if(index >= thumbs.length) index = 0;
        activeIndex = index;
        thumbs.forEach(function(t,i){
          t.classList.toggle('active',i===activeIndex);
          t.setAttribute('aria-current',i===activeIndex ? 'true' : 'false');
        });

        var activeThumb=thumbs[activeIndex];
        var mediaType=activeThumb.dataset.mediaType || 'image';
        if(mediaType === 'video' && mainVideoWrap){
          if(main) main.hidden=true;
          mainVideoWrap.hidden=false;
        }else{
          if(mainVideo){ try{ mainVideo.pause(); }catch(err){} }
          if(mainVideoWrap) mainVideoWrap.hidden=true;
          if(main) main.hidden=false;
          var url=activeThumb.dataset.imageUrl;
          if(url && main && main.src !== url){
            main.classList.add('is-changing');
            var preload=new Image();
            preload.onload=function(){
              main.src=url;
              requestAnimationFrame(function(){main.classList.remove('is-changing');});
            };
            preload.onerror=function(){main.src=url;main.classList.remove('is-changing');};
            preload.src=url;
          }
        }

        if(thumbsWrap){
          var targetLeft = activeThumb.offsetLeft - Math.max(0,(thumbsWrap.clientWidth - activeThumb.offsetWidth) / 2);
          if(typeof thumbsWrap.scrollTo === 'function'){
            try{ thumbsWrap.scrollTo({left:Math.max(0,targetLeft),behavior:'smooth'}); }
            catch(err){ thumbsWrap.scrollLeft=Math.max(0,targetLeft); }
          }else{
            thumbsWrap.scrollLeft=Math.max(0,targetLeft);
          }
        }
      }

      thumbs.forEach(function(thumb,index){
        thumb.addEventListener('click',function(){showMedia(index);});
      });

      if(mainWrap && thumbs.length > 1){
        var startX=0,startY=0,startTime=0;
        mainWrap.setAttribute('data-swipe-enabled','true');
        mainWrap.addEventListener('touchstart',function(e){
          if(!e.touches || e.touches.length!==1) return;
          startX=e.touches[0].clientX;
          startY=e.touches[0].clientY;
          startTime=Date.now();
        },{passive:true});
        mainWrap.addEventListener('touchend',function(e){
          if(!e.changedTouches || e.changedTouches.length!==1) return;
          var dx=e.changedTouches[0].clientX-startX;
          var dy=e.changedTouches[0].clientY-startY;
          var elapsed=Date.now()-startTime;
          if(elapsed>800 || Math.abs(dx)<42 || Math.abs(dx)<=Math.abs(dy)) return;
          showMedia(activeIndex + (dx<0 ? 1 : -1));
        },{passive:true});
      }
    });

    root.querySelectorAll('[data-product-form]').forEach(function(formWrap){
      if(formWrap.dataset.qtyInit) return;
      formWrap.dataset.qtyInit='1';
      var input=formWrap.querySelector('[data-qty-input]');
      var minus=formWrap.querySelector('[data-qty-minus]');
      var plus=formWrap.querySelector('[data-qty-plus]');
      var variantSelect=formWrap.querySelector('[data-variant-select]');
      var variantInput=formWrap.querySelector('[data-variant-id]');
      var message=formWrap.querySelector('[data-product-form-message]');
      var section=formWrap.closest('[data-section-id]');
      var priceEl=section ? section.querySelector('[data-product-price]') : null;
      var compareEl=section ? section.querySelector('[data-product-compare]') : null;
      var availabilityLine=section ? section.querySelector('[data-availability-line]') : null;
      var availabilityDot=section ? section.querySelector('[data-availability-dot]') : null;
      var availabilityText=section ? section.querySelector('[data-availability-text]') : null;
      var availabilityShipping=section ? section.querySelector('[data-availability-shipping]') : null;
      var bundleOptions=formWrap.querySelectorAll('[data-bundle-option]');
      function selectedBundle(){ return formWrap.querySelector('[data-bundle-option].is-selected'); }
      function selectBundle(option){
        if(!option || !input) return;
        bundleOptions.forEach(function(btn){
          var active=btn===option;
          btn.classList.toggle('is-selected',active);
          btn.setAttribute('aria-checked',active ? 'true' : 'false');
        });
        input.value=Math.max(1,parseInt(option.dataset.quantity||'1',10)||1);
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('genys:bundle-changed',{detail:{sectionId:section ? section.getAttribute('data-section-id') : '',quantity:parseInt(input.value,10)||1,price:option.dataset.bundlePrice||''}}));
      }
      bundleOptions.forEach(function(option){option.addEventListener('click',function(){selectBundle(option);});});
      if(bundleOptions.length){selectBundle(selectedBundle() || bundleOptions[0]);}
      if(minus) minus.addEventListener('click',function(){input.value=Math.max(1,parseInt(input.value||1,10)-1)});
      if(plus) plus.addEventListener('click',function(){input.value=Math.max(1,parseInt(input.value||1,10)+1)});
      if(variantSelect){
        variantSelect.addEventListener('change',function(){
          var option=variantSelect.options[variantSelect.selectedIndex];
          if(!option) return;
          if(variantInput) variantInput.value=option.value;
          var price=parseInt(option.dataset.price||'0',10);
          var compare=parseInt(option.dataset.compare||'0',10);
          var available=option.dataset.available==='true';
          if(priceEl) priceEl.textContent=money(price);
          if(compareEl){
            if(compare>price){compareEl.hidden=false;compareEl.textContent=money(compare);}else{compareEl.hidden=true;compareEl.textContent='';}
          }
          formWrap.querySelectorAll('[data-cart-action]').forEach(function(b){b.disabled=!available;});
          if(availabilityDot) availabilityDot.classList.toggle('is-out',!available);
          if(availabilityText && availabilityLine) availabilityText.textContent=available ? availabilityLine.dataset.inStock : availabilityLine.dataset.soldOut;
          if(availabilityShipping) availabilityShipping.hidden=!available;
          if(message) message.textContent=available ? '' : 'Šis variantas šiuo metu išparduotas.';
        });
      }

      var productForm=formWrap.closest('form');
      var buyNowLink=formWrap.querySelector('[data-buy-now-link]');

      function updateBuyNowLink(){
        if(!buyNowLink) return;
        var variantId=parseInt(variantInput ? variantInput.value : '',10);
        var quantity=Math.max(1,parseInt(input ? input.value : '1',10)||1);
        var selectedOption=variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
        var available=selectedOption ? selectedOption.dataset.available==='true' : !buyNowLink.classList.contains('is-disabled');
        if(!variantId || !available){
          buyNowLink.setAttribute('href','#');
          buyNowLink.setAttribute('aria-disabled','true');
          buyNowLink.classList.add('is-disabled');
          return;
        }
        buyNowLink.href=rootUrl()+'cart/'+encodeURIComponent(String(variantId))+':'+encodeURIComponent(String(quantity));
        buyNowLink.removeAttribute('aria-disabled');
        buyNowLink.classList.remove('is-disabled');
      }

      updateBuyNowLink();
      if(input) input.addEventListener('input',updateBuyNowLink);
      if(input) input.addEventListener('change',updateBuyNowLink);
      if(minus) minus.addEventListener('click',function(){setTimeout(updateBuyNowLink,0)});
      if(plus) plus.addEventListener('click',function(){setTimeout(updateBuyNowLink,0)});
      if(variantSelect) variantSelect.addEventListener('change',updateBuyNowLink);
      if(buyNowLink) buyNowLink.addEventListener('click',function(e){
        if(buyNowLink.getAttribute('aria-disabled')==='true') e.preventDefault();
      });

      if(productForm && !productForm.dataset.cartRedirectInit){
        productForm.dataset.cartRedirectInit='1';

        productForm.querySelectorAll('[data-cart-action]').forEach(function(btn){
          btn.addEventListener('click',function(){
            productForm.dataset.requestedCartAction=btn.dataset.cartAction || 'cart';
          });
        });

        function restoreButtons(buttons,submitter,oldText){
          buttons.forEach(function(b){b.disabled=false});
          if(submitter && oldText != null) submitter.textContent=oldText;
        }

        function nativeFallback(){
          try{
            HTMLFormElement.prototype.submit.call(productForm);
          }catch(err){
            window.location.assign(rootUrl()+'cart');
          }
        }

        productForm.addEventListener('submit',function(e){
          var requested=productForm.dataset.requestedCartAction || 'cart';
          var submitter=e.submitter || productForm.querySelector('[data-cart-action="'+requested+'"]') || productForm.querySelector('[data-cart-action]');
          if(!submitter || !submitter.matches('[data-cart-action]')) return;

          e.preventDefault();

          var action=submitter.dataset.cartAction || requested;
          var buttons=productForm.querySelectorAll('[data-cart-action]');
          var variantId=parseInt(variantInput ? variantInput.value : '',10);
          var quantity=Math.max(1,parseInt(input ? input.value : '1',10)||1);

          if(!variantId){
            if(message) message.textContent='Nepavyko nustatyti produkto varianto. Atnaujinkite puslapį ir bandykite dar kartą.';
            return;
          }

          buttons.forEach(function(b){b.disabled=true});
          var oldText=submitter.textContent;
          if(message) message.textContent='';
          submitter.textContent=action==='checkout' ? 'Ruošiama...' : 'Pridedama...';

          fetch(rootUrl()+'cart/add.js',{
            method:'POST',
            credentials:'same-origin',
            headers:{
              'Content-Type':'application/json',
              'Accept':'application/json',
              'X-Requested-With':'XMLHttpRequest'
            },
            body:JSON.stringify({items:[{id:variantId,quantity:quantity}]})
          })
          .then(function(r){
            if(!r.ok){
              return r.json().catch(function(){return {};}).then(function(err){
                throw new Error(err.description || err.message || 'add-to-cart');
              });
            }
            return r.json();
          })
          .then(function(){
            return fetch(rootUrl()+'cart.js',{
              credentials:'same-origin',
              headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
            })
            .then(function(r){
              if(!r.ok) throw new Error('cart-load');
              return r.json();
            })
            .then(function(cart){
              document.dispatchEvent(new CustomEvent('genys:cart-updated',{detail:{cart:cart}}));
              document.dispatchEvent(new CustomEvent('genys:cart-open'));
              if(message) message.textContent='Pridėta į krepšelį.';
              restoreButtons(buttons,submitter,oldText);
              productForm.dataset.requestedCartAction='';
              return cart;
            });
          })
          .catch(function(err){
            restoreButtons(buttons,submitter,oldText);
            productForm.dataset.requestedCartAction='';
            if(message) message.textContent=(err && err.message && err.message!=='add-to-cart') ? err.message : 'Nepavyko pridėti prekės. Bandome įprastu Shopify būdu.';
            nativeFallback();
          });
        });
      }
    });

    root.querySelectorAll('[data-faq]').forEach(function(list){
      if(list.dataset.faqInit) return;
      list.dataset.faqInit='1';
      list.querySelectorAll('.faq-item').forEach(function(item){
        var q=item.querySelector('.faq-q'); var a=item.querySelector('.faq-a');
        if(item.classList.contains('open') && a) a.style.maxHeight=a.scrollHeight+'px';
        if(q) q.addEventListener('click',function(){
          var open=item.classList.contains('open');
          list.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open');var x=i.querySelector('.faq-a');if(x)x.style.maxHeight=null});
          if(!open){item.classList.add('open');if(a)a.style.maxHeight=a.scrollHeight+'px'}
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

/* v22 — dynamic business-day ETA + sticky mobile add to cart */
(function(){
  function isBusinessDay(d){var day=d.getDay();return day!==0&&day!==6;}
  function nextBusinessDay(d){var x=new Date(d.getFullYear(),d.getMonth(),d.getDate());do{x.setDate(x.getDate()+1);}while(!isBusinessDay(x));return x;}
  function addBusinessDays(d,count){var x=new Date(d.getFullYear(),d.getMonth(),d.getDate());var added=0;while(added<count){x.setDate(x.getDate()+1);if(isBusinessDay(x))added++;}return x;}
  function ltDate(d,includeMonth){
    var months=['sausio','vasario','kovo','balandžio','gegužės','birželio','liepos','rugpjūčio','rugsėjo','spalio','lapkričio','gruodžio'];
    return includeMonth ? months[d.getMonth()]+' '+d.getDate()+' d.' : d.getDate()+' d.';
  }
  function renderEta(el){
    var out=el.querySelector('[data-delivery-eta-text]');if(!out)return;
    var min=Math.max(1,parseInt(el.dataset.minDays||'1',10)||1);
    var max=Math.max(min,parseInt(el.dataset.maxDays||'3',10)||3);
    var cutoff=Math.min(23,Math.max(0,parseInt(el.dataset.cutoffHour||'15',10)||15));
    var now=new Date();var start=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    if(!isBusinessDay(start)||now.getHours()>=cutoff)start=nextBusinessDay(start);
    var from=addBusinessDays(start,min);var to=addBusinessDays(start,max);
    if(from.getFullYear()===to.getFullYear()&&from.getMonth()===to.getMonth()){
      out.textContent=''+from.getDate()+'–'+to.getDate()+' '+['sausio','vasario','kovo','balandžio','gegužės','birželio','liepos','rugpjūčio','rugsėjo','spalio','lapkričio','gruodžio'][to.getMonth()]+' d.';
    }else{
      out.textContent=ltDate(from,true)+' – '+ltDate(to,true);
    }
  }
  function initV22(scope){
    var root=scope||document;
    root.querySelectorAll('[data-delivery-eta]').forEach(function(el){renderEta(el);});
    root.querySelectorAll('[data-mobile-buy-sticky]').forEach(function(sticky){
      if(sticky.dataset.v22Init)return;sticky.dataset.v22Init='1';
      var section=sticky.closest('[data-section-id]');if(!section)return;
      var stickyBtn=sticky.querySelector('[data-sticky-add]');
      var stickyPrice=sticky.querySelector('[data-sticky-price]');
      var stickyCompare=sticky.querySelector('[data-sticky-compare]');
      var formWrap=section.querySelector('[data-product-form]');
      var primary=formWrap?formWrap.querySelector('[data-cart-action="cart"]'):null;
      var variantSelect=formWrap?formWrap.querySelector('[data-variant-select]'):null;
      var priceEl=section.querySelector('[data-product-price]');
      var compareEl=section.querySelector('[data-product-compare]');
      function sync(){
        var selected=section.querySelector('[data-bundle-option].is-selected');
        if(stickyPrice){
          if(selected && selected.dataset.bundlePrice) stickyPrice.textContent=selected.dataset.bundlePrice;
          else if(priceEl) stickyPrice.textContent=priceEl.textContent;
        }
        if(stickyCompare&&compareEl){
          if(selected){stickyCompare.hidden=true;stickyCompare.textContent='';}
          else{stickyCompare.hidden=compareEl.hidden;stickyCompare.textContent=compareEl.textContent;}
        }
        if(stickyBtn&&primary){stickyBtn.disabled=primary.disabled;}
      }
      sync();
      if(stickyBtn)stickyBtn.addEventListener('click',function(){sync();if(primary&&!primary.disabled){primary.click();}});
      if(variantSelect)variantSelect.addEventListener('change',function(){setTimeout(sync,0);});
      document.addEventListener('genys:bundle-changed',function(e){
        if(!e.detail || !e.detail.sectionId || e.detail.sectionId===section.getAttribute('data-section-id')) setTimeout(sync,0);
      });
      if(formWrap){
        var observer=new MutationObserver(sync);observer.observe(formWrap,{subtree:true,attributes:true,attributeFilter:['disabled']});
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initV22(document)});else initV22(document);
  document.addEventListener('shopify:section:load',function(e){initV22(e.target)});
})();
